// extracted by mini-css-extract-plugin
module.exports = {"searchDesktop":"Corsi_searchDesktop__1uE2N","searchMobile":"Corsi_searchMobile__vZAws"};